import type { SVGProps } from "react";
const SvgTrips = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path d="M22.5 21.5s-4.5-3-10.5-3c-5 0-7.5 2-10 3.5m15 .86S15.02 22 12.39 22c-2.2 0-3.3.57-4.39 1m7.5-19s-3 2-4 5m5-4.5s1.5 3.5.5 6" />
      <path d="M15.9 3.8a7.44 7.44 0 0 0-8.3 3.99c-.31.63-.47.95-.27 1.23.2.3.59.25 1.37.18l1.74-.18c.27-.02.53.04.75.18l2.88 1.82 3.43-.34c.26-.03.52.03.74.17l1.5.95c.65.4.97.61 1.28.45.3-.15.3-.5.33-1.18A7.15 7.15 0 0 0 15.9 3.8m-1.35 7.51L13 18.5m2.92-14.83V3" />
    </g>
  </svg>
);
export default SvgTrips;
